import { Controller } from "stimulus";
import Micromodal from "micromodal";
import PubSub from "pubsub-js";

/**
 * Basic Micromodal modal
 */
export default class extends Controller {
    scripts = [];
    static targets = ["lazy", "content"];
    triggerClickHandler = () => {}

    get triggers()
    {
        const id = this.element.getAttribute("id");
        return document.querySelectorAll(`.modal-trigger-${id}`);
    }

    get form()
    {
        return this.element.querySelector(".gform_wrapper");
    }

    get formAnchor()
    {
        return this.element.querySelector(".gform_anchor");
    }

    get formConfirmation() {
        return this.element.querySelector(".gform_confirmation_wrapper");
    }

    get formId()
    {
        if (this._formId) {
            return this._formId
        }

        if (!this.formAnchor) {
            return 16;
        }

        const formId = this.formAnchor.getAttribute("id").split("_")[1];

        if (formId) {
            this._formId = formId
        }

        return formId;
    }

    get formReloader()
    {
        return window[`gwrf_` + this.formId] || null;
    }


    connect()
    {
        this.triggerClickHandler = (e) => {
            e.preventDefault;
            this.handleTriggerClick(e.currentTarget);
        };
        Micromodal.init();
        this.addTriggers();
        this.delayScripts();
    }

    disconnect()
    {
        this.triggers.forEach((trigger) => {
            trigger.removeEventListener("click", this.triggerClickHandler);
        });
    }

    handleTriggerClick(trigger)
    {
        const id = this.element.getAttribute("id");
        let params = trigger.dataset.modalOpenedParams;
        Micromodal.show(id, {
            onShow: () => {
                if (params) {
                    params = JSON.parse(params);
                    PubSub.publish(`${id}-modal:opened`, params);
                    PubSub.publish(`modal:opened`, params);
                } else {
                    PubSub.publish(`${id}-modal:opened`);
                    PubSub.publish(`modal:opened`);
                }
            },
            onClose: () => {
                PubSub.publish(`${id}-modal:closed`);
                PubSub.publish(`modal:closed`);
                this.handleModalClosed()
            },
        });
        this.injectLazyContent();
    }

    delayScripts()
    {
        this.scripts = this.element.querySelectorAll("script");
        this.scripts.forEach((script) => {
            script.remove();
        });
    }

    addTriggers()
    {
        this.triggers.forEach((trigger) => {
            trigger.addEventListener("click", this.triggerClickHandler);
        });
    }

    injectLazyContent()
    {
        if (!this.hasLazyTarget || !this.data.has("lazy")) {
            return;
        }

        const json = this.data.get("lazy");
        const html = JSON.parse(json).content;
        this.contentTarget.innerHTML = html;
    }


    handleModalClosed()
    {
        if (this.formConfirmation) {
            this.reload();
        }
    }

    reload()
    {
        if (!this.formReloader) {
            return;
        }

        this.formReloader.reloadForm();
    }
}
